import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  template: `
    <main class="auth-callback">
      <section>
        <h1>Signing you in...</h1>
        <p>Please wait while Microsoft redirects you back to the application.</p>
      </section>
    </main>
  `,
  styles: [`
    .auth-callback {
      min-height: 100vh;
      display: grid;
      place-items: center;
      background: #f4f6f5;
      color: #273331;
      text-align: center;
    }

    h1 {
      margin: 0 0 8px;
      color: #1f4f40;
      font-size: 24px;
      line-height: 32px;
    }

    p {
      margin: 0;
      color: #596360;
    }
  `],
})
export class AuthCallbackComponent implements OnInit {
  private readonly auth = inject(AuthService);

  ngOnInit(): void {
    void this.auth.initialize();
  }
}